import "./ksopHeaderInformation.css";
import { principalFinanceLogo } from "../../../../../../assets";

/* eslint-disable */

const KsopHeaderInformation = (props) => {
	return (
		<div className="ksop-header-information">
			<h1 className="main-header">Employee Stock Ownership Form</h1>
			<hr className="horizontal-line"></hr>
			<div className="flex1-container">
				<img
					src={principalFinanceLogo}
					className={props.isPrintable ? "principal-finance-logo-small" : "principal-finance-logo"}
					id="principal-finance-logo"
					alt="Principal Finance Logo"
				/>
				<div className={"header2 " + (props.isPrintable ? "font-size-12" : "font-size-14")}>
					<p>
						<b>Principal Life Insurance Company</b>
					</p>
					<p>
						Des Moines, IA 50392-0001<br></br>
						1-800-547-7754<br></br>
						FAX 1-866-704-3481<br></br>
						1-800-547-7754<br></br>
						www.principal.com<br></br>
						<i>A member of the Principal Finance Group</i>
					</p>
				</div>
				<div className="side-header">
					<h3>
						<b>
							<i>Retirement Plan</i>
							<br></br>
							<i>Beneficiary Designation</i>
						</b>
					</h3>
					<p className="ctd">
						<b>CTD</b> 01304
					</p>
				</div>
			</div>
		</div>
	);
};

export default KsopHeaderInformation;
